import React from "react";
import Button from "@semcore/button";
import Modal from "@semcore/modal";
import { Text } from "@semcore/typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Flex } from "@semcore/ui/flex-box";
import Input from "@semcore/ui/input";
import axios from "axios";
import { PUT_LINKUPDATE } from "../../utils/services";
import AddProjectStore from "../../../store/AddProjectStore";
import { GET_LINKFEATURE_API } from "../../../Adsy/services/api";
import AdminZustandStore from "../../AdminZustandStore";

const PostBuyLinkType = ({
  visible,
  setVisible,
  SelectedDomain,
  setSelectedDomain,
}) => {
  let cost = SelectedDomain?.[0]?.Cost;
  let status_type =
    SelectedDomain?.[0]?.Buy === "Buy Now" ? "buynow" : "enquiry";

  const [text, setText] = React.useState(cost);
  const [value, setValue] = React.useState(status_type);
  const [loader, setLoader] = React.useState(false);

  const { showNotification } = AddProjectStore((state) => state);

  const handleClose = React.useCallback(() => setVisible(false), []);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const getLinkFeature = async () => {
    AdminZustandStore.setState({
      guestPost: {
        data: [],
        loading: true,
        error: false,
      },
    });
    try {
      const resp = await axios.get(GET_LINKFEATURE_API());
      AdminZustandStore.setState({
        guestPost: {
          data: resp.data,
          loading: false,
          error: false,
        },
      });
    } catch (error) {
      AdminZustandStore.setState({
        guestPost: {
          data: [],
          loading: false,
          error: "Server Error",
        },
      });
    }
  };

  const handleSaveChanges = async () => {
    setLoader(true);
    const costCanUpdate = SelectedDomain?.length === 1;
    const data = SelectedDomain?.map((item) => {
      return {
        URL: item.URL,
        cost: costCanUpdate ? text || cost : item.Cost,
        buy: value,
      };
    });
    try {
      const resp = await axios.put(PUT_LINKUPDATE(), { data: data });
      showNotification({
        message: "Guest post link Updated successfully 🎉",
        severity: "success",
      });
      getLinkFeature();
      setSelectedDomain([]);
      handleClose();
    } catch (error) {
      showNotification({
        message: "Unexpected error occurred 🤷‍♂️",
        severity: "error",
      });
      setSelectedDomain([]);
      handleClose();
    }
  };

  return (
    <React.Fragment>
      <Modal visible={visible} onClose={handleClose}>
        <Modal.Title>Update Buy Guest Posts Link</Modal.Title>

        <Flex direction="column" gap={2} mb={3}>
          {SelectedDomain?.length > 1 ? null : (
            <Flex direction="column">
              <Text tag="label" htmlFor="cost-example" size={200}>
                Cost
              </Text>
              <Input w={240}>
                <Input.Value
                  placeholder={cost}
                  type="text"
                  autoComplete="off"
                  id="cost-example"
                  value={text}
                  onChange={(e) => setText(e)}
                />
              </Input>
            </Flex>
          )}
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="enquiry"
                control={<Radio />}
                label="Enquiry"
              />
              <FormControlLabel
                value="buynow"
                control={<Radio />}
                label="Buy Now"
              />
            </RadioGroup>
          </FormControl>
        </Flex>

        <Button
          use="primary"
          theme="success"
          loading={loader}
          size="m"
          onClick={handleSaveChanges}
        >
          Save changes
        </Button>
        <Button size="m" ml={2} onClick={handleClose}>
          Don't save
        </Button>
      </Modal>
    </React.Fragment>
  );
};

export default PostBuyLinkType;
